import axios from "axios";
//   const BASE_URL='/api';
import router from '../router/index';
import {Message} from 'element-ui';
import store from '../store/index';
import { getCurrentOpenPageList } from "../common/loginout";

// let requests=[];
// let isRefereshing=false;
// const htp=axios.create({
//     baseURL:'/',
//     timeout:6000,
//     Authorization:(getlocalToken())
// });
// function getlocalToken(){
//     let tokenObj=localStorage.getItem("token");
// if(tokenObj){
//     tokenObj=JSON.parse(tokenObj);
// }
// const token=tokenObj?"Bearer "+tokenObj.token:"";
//     return token;
// }
// htp.setToken=(token)=>{
// htp.defaults.headers.Authorization="Bearer "+token;
// store.dispatch('saveToken',token);
// };
// function refereshToken(){
//     let tokenObj=localStorage.getItem("token");
//     if(tokenObj){
//         tokenObj=JSON.parse(tokenObj);
//     }
//     const token=tokenObj?tokenObj.token:"";
//     return htp.get('/login/refreshToken?token='+token).then(res=>res.data);
// }
export function getHttp(url) {
    let tokenObj=localStorage.getItem("token");
if(tokenObj){
    tokenObj=JSON.parse(tokenObj);
}
const token=tokenObj?"Bearer "+tokenObj.token:"";
const axiosObj={
    BASE_URL: '/api',
    headers: {
       'Content-Type': 'application/json; charset=utf-8',
       Authorization:token
     }
  };
const htp=axios.create(axiosObj);
    // const openPageList=getCurrentOpenPageList();
    // if(openPageList.length===0&&store.state.isShowMsg===false){  
    //     Message({message:"页面还没加载完，请稍等一会儿"});
    //     return;
    // }
    return new Promise((resolve,reject)=>{
        htp.get(url).then((res)=>{
            resolve(res);
        }).catch((err)=>{
            reject(err);
        });
    });
}
export function postHttp(url,data,obj=null){
    let tokenObj=localStorage.getItem("token");
if(tokenObj){
    tokenObj=JSON.parse(tokenObj);
}
const token=tokenObj?"Bearer "+tokenObj.token:"";
const axiosObj={
    BASE_URL: '/api',
    headers: {
       'Content-Type': 'application/json; charset=utf-8',
       Authorization:token
     }
  };
const htp=axios.create(axiosObj);
    // const openPageList=getCurrentOpenPageList();
    // if(openPageList.length===0&&store.state.isShowMsg===false){  
    //     Message({message:"页面还没加载完，请稍等一会儿"});
    //     return;
    // }
    if(data){
        return new Promise((resolve,reject)=>{
            if(obj){
                htp.post(url,data,obj).then(res=>{
                    resolve(res);
                }).catch(err=>{
                    reject(err);
                });
            }else{
                htp.post(url,data).then(res=>{
                    resolve(res);
                }).catch(err=>{
                    reject(err);
                });
            }
        });
    }else{
        return new Promise((resolve,reject)=>{
            htp.post(url).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            });
        });
    }
}
export function putHttp(url,data){
    let tokenObj=localStorage.getItem("token");
if(tokenObj){
    tokenObj=JSON.parse(tokenObj);
}
const token=tokenObj?"Bearer "+tokenObj.token:"";
const axiosObj={
    BASE_URL: '/api',
    headers: {
       'Content-Type': 'application/json; charset=utf-8',
       Authorization:token
     }
  };
const htp=axios.create(axiosObj);
    // const openPageList=getCurrentOpenPageList();
    // if(openPageList.length===0&&store.state.isShowMsg===false){  
    //     Message({message:"页面还没加载完，请稍等一会儿"});
    //     return;
    // }
    if(data){
        return new Promise((resolve,reject)=>{
            htp.put(url,data).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            });
        });
    }else{
        return new Promise((resolve,reject)=>{
            htp.put(url).then(res=>{
                resolve(res);
            }).catch(err=>{
                reject(err);
            });
        });
    }
}
export function deleteHttp(url){
    let tokenObj=localStorage.getItem("token");
if(tokenObj){
    tokenObj=JSON.parse(tokenObj);
}
const token=tokenObj?"Bearer "+tokenObj.token:"";
const axiosObj={
    BASE_URL: '/api',
    headers: {
       'Content-Type': 'application/json; charset=utf-8',
       Authorization:token
     }
  };
const htp=axios.create(axiosObj);
    // const openPageList=getCurrentOpenPageList();
    // if(openPageList.length===0&&store.state.isShowMsg===false){  
    //     Message({message:"页面还没加载完，请稍等一会儿"});
    //     return;
    // }
    return new Promise((resolve,reject)=>{
        htp.delete(url).then(res=>{
            resolve(res);
        }).catch(err=>{
            reject(err);
        });
    });
};
//  query: {redirect: router.currentRoute.fullPath}
axios.interceptors.response.use(async (response)=>{
    if(response.status === 200 && response.data.code === 500 && response.data.msg === '未登录'){
        store.commit('initRecommend');
        store.commit('initSchoolFind');
        store.commit('initUserInfo');
        store.commit('initToken');
        Message.error({message: '登录超时，请重新登录'});
        router.replace({
            path: '/main/home',
        });
    }
    return response;
},error=>{
    console.log(error);
    if(error.response.status === 504){
        Message.error({message: '服务器可能未开启,请稍后再试'});
    }
    return Promise.reject(error.response.data);// 返回接口返回的错误信息
});
// axios.interceptors.request.use(async function(config){

//     return config;
// },function(error){
//     return Promise.reject(error);
// });
// htp.interceptors.response.use(async response=>{
//     const {code}=response.data;
//     if(code===401){
//         if(!isRefereshing){
//             isRefereshing=true;
//             return refereshToken().then(res=>{
//                 const {token}=res.data;
//                 htp.setToken(token);
//                 response.config.headers.Authorization=token;
//                 response.config.baseURL='';
//                 requests.forEach(cb=>cb(token));
//                 requests=[];
//             }).catch(res=>{
//                 router.push('/main/home');
//             }).finally(()=>{
//                 isRefereshing=false;
//             });
//         }else{
//             return new Promise((resolve)=>{
//                 requests.push((token)=>{
//                     response.config.baseURL='';
//                     response.headers.Authorizatio=token;
//                     resolve(htp(response.config));
//                 });
//             });
//         }
//     }
//     if(response.status===401){
//         if(!isRefereshing){
//             isRefereshing=true;
//             return refereshToken().then(res=>{
//                 const token=res.data;
//                 htp.setToken(token);
//                 response.config.headers.Authorization="Bearer "+token;
//                 response.config.baseURL='/';
//                 const tokenParameter="Bearer "+token;
//                 requests.forEach(cb=>cb((tokenParameter)));
//                 requests=[];
//             }).catch(async res=>{
//                 await store.dispatch("loginOut",{sjhm:store.state.userInfo.sjhm});
//             }).finally(()=>{
//                 isRefereshing=false;
//             });
//         }else{
//             return new Promise((resolve)=>{
//                 requests.push((token)=>{
//                     response.config.baseURL='/';
//                     response.headers.Authorization=token;
//                     resolve(htp(response.config));
//                 });
//             });
//         }
//     }
//     return response;
// },async err=>{
//     console.log(err);
//     // if(err.response.status===401){
//     //     const refereshToken=getlocalToken();
//     //     if(refereshToken){
//     //         try {
//     //             const res=await axios({
//     //                 method:'GET',
//     //                 url:'/login/refreshToken?token='+refereshToken,
//     //                 headers:{
//     //                     Authorization:refereshToken
//     //                 }
//     //             });
//     //             console.log(res);
//     //             const newToken=res.data.token;
//     //             console.log(newToken);
//     //         } catch (error) {
//     //             router.push({
//     //                 path:'/login',
//     //                 query:{
//     //                     backto:router.currentRoute.fullPath
//     //                 }
//     //             });
//     //         }
//     //     }else{
//     //         router.push({
//     //             path:'/login',
//     //             query:{
//     //                 backto:router.currentRoute.fullPath
//     //             }
//     //         });
//     //     }
//     // }
//     return Promise.reject(err);
// });
export default {
    postHttp,
    getHttp,
    putHttp,
    deleteHttp
};
